var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-nav h-full w-full absolute top-0 bottom-0 z-40"},[_c('PageNavigation'),_c('SubPageNavigation'),_c('MicroPageNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }